import { Route } from "@izettle/react-spa"

import { Pages } from "./constants"

export const routes: Route[] = [
  {
    path: Pages.ReceiptDetails,
    component: () =>
      import(/* webpackChunkName: "receipt-details" */ "./receipts/details").then(
        (module) => ({
          default: module.ReceiptDetails,
        }),
      ),
  },
  {
    path: Pages.ReceiptList,
    component: () =>
      import(/* webpackChunkName: "receipt-list" */ "./receipts").then((module) => ({
        default: module.ReceiptsPage,
      })),
    options: { exact: true },
  },
  {
    path: Pages.ReceiptDetailsV2,
    component: () =>
      import(/* webpackChunkName: "receipt-details" */ "./receipts/details").then(
        (module) => ({
          default: module.ReceiptDetails,
        }),
      ),
  },
  {
    path: Pages.ReceiptListV2,
    component: () =>
      import(/* webpackChunkName: "receipt-list" */ "./receipts").then((module) => ({
        default: module.ReceiptsPage,
      })),
    options: { exact: true },
  },
]
